import { useTranslation } from 'react-i18next';
import { TexturedBackground } from '../core/layouts/TexturedBackground';
import { CenteredContentLayout } from '../core/text/ContentTypography';
import { LandingOnboardingCard } from '../core/text/LandingTypography';
import { BodyLarge, TitleLarge } from '../core/text/Typography';

export default function NotFoundPageContent() {
    const { t } = useTranslation();

    return (
        <TexturedBackground>
            <CenteredContentLayout>
                <LandingOnboardingCard>
                    <TitleLarge>404.</TitleLarge>
                    <BodyLarge>{t('common:notFoundDescription')}</BodyLarge>
                </LandingOnboardingCard>
            </CenteredContentLayout>
        </TexturedBackground>
    );
}
